// extracted by mini-css-extract-plugin
export default {"onboardingForm":"PkRRF6yi_jyUE43uBvm3__onboardingForm___","submitButton":"iYpy66TZhYcjSf_KZOPX__submitButton___"};